module.exports = __webpack_public_path__ + "img/ico-support.a7c3c7bc.svg";